(() => {
  const debounceMillisconds = 300;
  const debounceMap = new Map();
  const popperMap = window.WeakMap ? new WeakMap() : new Map();
  const popperUrl = `${window.swinger.config.assetsBase}/popper.js?v=${window.swinger.config.version}`;
  const widgets = {};

  window.swinger.eventHub.register('click mouseenter', '[data-popover], [data-popover] *', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('[data-popover]');
    let options = JSON.parse(elem.getAttribute('data-popover'));
    const elemGeometry = !options.placement ? elem.getBoundingClientRect() : {};

    if (typeof options === 'string') {
      options = {
        components: options,
      };
    }

    if (!options.component) {
      return;
    }

    switch (options.openEvents) {
      default:
        break;

      case 'mouseenter':
        options.openEvents = 'mouseenter click';
        break;
    }

    if (options.openEvents) {
      const openEvents = options.openEvents.split(' ');
      if (openEvents.indexOf(e.type) === -1) {
        return;
      }
    }

    debounceMap.forEach((value, key, map) => {
      window.clearTimeout(map.get(key));
    });
    debounceMap.set(elem, window.setTimeout(() => {
      window.swinger.resourceLoader.script(popperUrl, () => {
        const optionsJson = JSON.stringify(options);

        if (!widgets[optionsJson]) {
          widgets[optionsJson] = window.swinger.widgets.create({
            type: 'data-popover',
            initialState: options,
          });
        }

        const widget = widgets[optionsJson];
        const appendContainer = document.getElementById('swinger-append-container')
          || window.swinger.$('body', document)[0];

        if (!appendContainer.contains(widget)) {
          appendContainer.appendChild(widget);
        }

        const dialog = widget.querySelector('dialog,[role="dialog"]');
        if (dialog) {
          window.swinger.visibility.show(dialog);
        }

        if (!popperMap.get(elem)) {
          const popper = new window.Popper(elem, widget, {
            // eslint-disable-next-line no-nested-ternary
            placement: options.placement ? options.placement : (elemGeometry.top > 350 ? 'top' : 'bottom'),
            modifiers: {
              preventOverflow: {
                boundariesElement: document.body,
                padding: 10,
              },
              arrow: {
                enabled: true,
              },
              removeOnDestroy: true,
            },
            eventsEnabled: false,
          });
          popperMap.set(elem, popper);
        }

        const unregisterCallback = () => {
          window.swinger.overlayManager.unregister(widget);
          if (widget && widget.parentNode) {
            widget.parentNode.removeChild(widget);
          }
          const popper = popperMap.get(elem);

          if (popper) {
            popper.destroy();
            popperMap.delete(elem);
          }
        };

        window.swinger.overlayManager.register(
          widget,
          unregisterCallback,
          elem,
          options.closeEvents === undefined,
        );

        window.swinger.visibility.observe(widget, (visible) => {
          if (visible) {
            return;
          }

          const dialog = widget.querySelector('dialog[id],[role="dialog"][id]');
          if (dialog) {
            const overlayId = dialog.id;
            const invoker = document.querySelector(`[aria-controls="${overlayId}"][data-invoker]`);

            if (invoker) {
              invoker.removeAttribute('data-invoker');
              invoker.focus();
            }
          }

          unregisterCallback();
        });

        if (options.closeEvents === undefined || options.closeEvents) {
          [elem, widget].forEach((entry) => {
            window.swinger.eventHub.register(options.closeEvents || 'mouseleave', entry, () => {
              window.clearTimeout(debounceMap.get(elem));
              debounceMap.set(elem, window.setTimeout(unregisterCallback, debounceMillisconds));
            });
          });

          window.swinger.eventHub.register('mouseenter', widget, () => {
            window.clearTimeout(debounceMap.get(elem));
          });
        }

        window.swinger.eventHub.register('click', () => widget.querySelector('.swinger-data-popover__close'), (e) => {
          const elem = window.swinger.eventHub.getTarget(e);

          if (!elem.closest('.swinger-data-popover__close')) {
            return;
          }

          unregisterCallback();
        });

        window.swinger.eventHub.register('resize', window, () => {
          if (e.type !== 'resize') {
            return;
          }

          unregisterCallback();
        });

        window.swinger.eventHub.register('scroll', window, () => {
          if (e.type !== 'scroll') {
            return;
          }

          unregisterCallback();
        });

        document.addEventListener('swinger.overlay:open', (e) => {
          if (!e.detail || !e.detail.elem || e.detail.elem === widget) {
            return;
          }

          unregisterCallback();
        });

        document.addEventListener('swinger-data-popover:close', () => {
          unregisterCallback();
        });

        window.swinger.eventHub.register('swinger-widget:rendered', widget, () => {
          const popper = popperMap.get(elem);
          popper.update();
        });
      });
    }, e.type === 'click' ? 0 : debounceMillisconds));

    if (e.type === 'click') {
      if (window.matchMedia('(hover: hover)').matches) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  });

  window.swinger.observer.initialize('.swinger-data-popover', (elem) => {
    window.swinger.visibility.observe(elem, (visible) => {
      if (!visible) {
        return;
      }

      if (elem.showModal && elem.matches('.swinger-data-popover--is-modal')) {
        // Safeguards against error when modal is already open
        try {
          elem.showModal();
        } catch (e) {
          // noop
        }
      }

      const firstFocusableElement = elem.querySelector(window.swinger.focusableElements.join(','));

      if (!firstFocusableElement) {
        return;
      }

      firstFocusableElement.focus({ preventScroll: true });
    });
  });
})();
